import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './Avatar.module.scss';
export const Avatar = ({ avatar, name, style }) => {
    return _jsx("img", { className: cn(styles.avatar, style), src: avatar, alt: name });
};
